module.exports = __webpack_public_path__ + "img/download_bg.f71e27e1.png";